export { default } from './ModuleContent';
